<template>
  <div class="homepage">
    <div class="homepage__bg">
      <img
        src="/images/header-bg.jpg"
        alt="bg"
        class="homepage__image-bg"
      >
      <div class="homepage__text">
        <h1 class="homepage__title">
          Maximise your Performance
        </h1>
        <div class="homepage__logo-wrapper">
          <img
            src="/images/header-bg-logo.png"
            alt="logo"
            class="homepage__logo"
          >
        </div>
      </div>
    </div>
    <div class="homepage__products">
      <products-component :products="products" />
    </div>
    <detail-product-component
      v-for="(product, index) in products"
      :id="`product-${product.id}`"
      :key="index"
      :product="product"
    />
  </div>
</template>
<script>
import ProductsComponent from '@/components/ProductsComponent.vue';
import DetailProductComponent from '@/components/DetailProductComponent.vue';

export default {
  name: 'Home',
  components: {
    ProductsComponent,
    DetailProductComponent,
  },
  data: () => ({
    products: [
      {
        id: 1,
        image: '/images/Gel-lime.png',
        imageSmall: '/images/Lime-small.png',
        name: 'Lime & Mint Cooler',
        nameChunks: ['Lime &', 'Mint Cooler'],
        className: 'mint',
        type: 'energy gel',
        addition: 'with electrolytes',
        composition: ['28.5g Carb', '5mg calcium', '55mg Sodium', '24mg Potassium'],
        advantages: 'Suitable for vegans and vegetarians',
        calories: '114 calories',
        carbs: '28.5g Carbs',
        sodium: '55mg sodium',
        advImage: '/images/Lime-Detail-bg.jpg',
      },
      {
        id: 2,
        image: '/images/Gel-jaffa.png',
        imageSmall: '/images/Jaffa-small.png',
        name: 'Jaffa Cake',
        nameChunks: ['Jaffa', 'Cake'],
        className: 'cake revert',
        type: 'energy gel',
        addition: 'with electrolytes',
        composition: ['28.5g Carb', '5mg calcium', '55mg Sodium', '24mg Potassium'],
        advantages: 'Suitable for vegans and vegetarians',
        calories: '114 calories',
        carbs: '28.5g Carbs',
        sodium: '55mg sodium',
        advImage: '/images/Jaffa-Detail-bg.jpg',
      },
      {
        id: 3,
        image: '/images/Tabs-apple.png',
        imageSmall: '/images/Apple-small.png',
        name: 'Apple',
        className: 'apple',
        addition: 'with sodium & other electrolytes',
        type: 'hydro tabs',
        composition: ['345mg Sodium', 'Vitamins B1, B2, B6', 'Low calorie content'],
        advantages: 'Suitable for vegans and vegetarians',
        calories: 'Low calorie content',
        carbs: '20 Tablets',
        sodium: '345mg Sodium',
        advImage: '/images/Apple-Detail-bg.jpg',
      },
      {
        id: 4,
        image: '/images/Tabs-berry.png',
        imageSmall: '/images/Berry-small.png',
        name: 'Berry',
        className: 'berry revert',
        type: 'hydro tabs',
        addition: 'with sodium & other electrolytes',
        composition: ['345mg Sodium', 'Vitamins B1, B2, B6', 'Low calorie content'],
        advantages: 'Suitable for vegans and vegetarians',
        calories: 'Low calorie content',
        carbs: '20 Tablets',
        sodium: '345mg Sodium',
        advImage: '/images/Berry-Detail-bg.jpg',
      },
    ],
  }),
};
</script>
<style
  lang="scss"
  scoped
>
  .homepage {
    &__bg {
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      max-width: 1600px;
      margin: 0 auto;
    }

    &__image-bg {
      width: 100%;
    }

    &__text {
      position: absolute;
      bottom: 0;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      left: 0;
      right: 0;

      @include respond-to(tablet) {
        bottom: auto;
      }
    }

    &__title {
      color: $theme-color-light;
      font-size: 2.65em;
      letter-spacing: 8.4px;
      margin-bottom: 43px;

      @include respond-to(tablet) {
        display: none;
      }
    }

    &__logo-wrapper {
      width: 112px;
      margin-bottom: 90px;

      @include respond-to(tablet) {
        margin-bottom: 0;
      }

      @include respond-to(mobile) {
        width: 60px;
      }
    }

    &__logo {
      width: 100%;
    }

    &__products {
      max-width: 1600px;
      margin: 0 auto;
    }
  }
</style>
